module.exports = __webpack_public_path__ + "static/author-6e326b16818dfff6dd76c5b6569d041b.png";